import { termsAndConditionComponent } from './terms-and-condition.component';
import { TermsAndConditionService } from './terms-and-condition.service';

export const termsAndCondition = angular
     .module('components.termsAndCondition', [])
     .service('TermsAndConditionService', TermsAndConditionService)
     .component('termsAndCondition', termsAndConditionComponent)
     .config(($stateProvider) => {
     	'ngInject';

     	$stateProvider
		.state('TermsAndCondition', {
			url: '/terms-and-conditions',
			component: 'termsAndCondition',
			breadcrumbName: 'Terms & Conditions',
			parentState: 'Home',
               resolve: {
                    details(TermsAndConditionService) {
                         'ngInject';

                         return TermsAndConditionService.getTermsAndConditionDetails()
                    }
               }
		});
     })
     .name;


// WEBPACK FOOTER //
// ./src/app/components/terms-and-condition/terms-and-condition.module.js